export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-page-calendar/index.js